import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

import './bn-tab';

class BnTabs extends LitElement {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
        padding: 0 .5rem;
        margin: var(--root-margin);
      }
    `];
  }

  render() {
    return html`
      <div class="tabs">
        <slot @slotchange="${this._slotchange}"></slot>
      </div>
    `;
  }

  _slotchange() {
    const tabs = this.querySelectorAll('bn-tab');
    const tabClick = (clickedTab) => {
      this.selected = Array.prototype.indexOf.call(tabs, clickedTab);
      tabs.forEach((tab) => tab.active = tab === clickedTab);
      this.dispatchEvent(new CustomEvent('select', { detail: { selected: this.selected } }));
    };
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => tabClick(tab));
      if (tab.active) {
        tabClick(tab);
      }
    });
  }
}

window.customElements.define('bn-tabs', BnTabs);
